import { API } from "./api";

const CHUNK = 700 * 1024;
export const IMAGE_MAX = 5 * 1024 * 1024;
export const VIDEO_MAX = 100 * 1024 * 1024;
export const mediaUrl = (u) => (u && u.startsWith("/api/") ? `${API}${u.replace(/^\/api/, "")}` : u);

// Public chunked upload for testimonial photos/videos → returns {media_id, kind}.
export async function uploadTestimonialMedia(file, onProgress) {
  const isVideo = file.type.startsWith("video/");
  if (file.size > (isVideo ? VIDEO_MAX : IMAGE_MAX)) throw new Error(isVideo ? "Videos must be 100 MB or smaller" : "Photos must be 5 MB or smaller");
  const dataUrl = await new Promise((res, rej) => { const r = new FileReader(); r.onload = () => res(r.result); r.onerror = rej; r.readAsDataURL(file); });
  const b64 = dataUrl.split(",")[1];
  const total = Math.ceil(b64.length / CHUNK);
  const upload_id = crypto.randomUUID();
  let result = null;
  for (let index = 0; index < total; index++) {
    const r = await fetch(`${API}/impact-testimonials/upload/chunk`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ upload_id, index, total, data: b64.slice(index * CHUNK, (index + 1) * CHUNK), name: file.name, mime: file.type }) });
    if (!r.ok) throw new Error((await r.json().catch(() => ({}))).detail || "Upload failed");
    const data = await r.json();
    onProgress?.(Math.round(((index + 1) / total) * 100));
    if (data.complete) result = data;
  }
  return result;
}
